// extracted by mini-css-extract-plugin
export var typingIndicator = "_sc-0";